import { render, staticRenderFns } from "./AnswersReportEmptyStates.vue?vue&type=template&id=4cf25281&"
import script from "./AnswersReportEmptyStates.vue?vue&type=script&lang=js&"
export * from "./AnswersReportEmptyStates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports